import { computed } from 'vue'
import { useStore } from 'vuex'

/** Gift Aid authorisation state from the donor store. */
export function useSwiftaidAuthorisationStatus() {
  const store = useStore()

  const isStatusKnown = computed(() =>
    Boolean(store.getters.authorisationStatusKnown)
  )

  const isAuthorised = computed(() => Boolean(store.getters.swiftaidAuthorised))

  return {
    isStatusKnown,
    isAuthorised,
  }
}
